import {createSlice,createAsyncThunk} from "@reduxjs/toolkit";

const data = [];

const testsSlice = createSlice({
    name:'tests', 
    initialState:{ 
        loading: false,
        tests :data
    },
    reducers:{
        add_tests:(state,action)=>{
            state.tests = action.payload
        },
        delete_tests:(state)=>{
            state.tests = []
        }

    }
})

export const {add_tests,delete_tests} = testsSlice.actions;
export default testsSlice.reducer; 